//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import banner from '@/assets/chunjiedati/banner.png'
export default {
  name: 'zzwdgruleIndex',
  components: {
  },
  data () {
    return {
      banner: banner
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  },
  created () {
  }
}
